import { CheckoutCustomerPrompt, CustomerPromptTypes } from '@ordering/gql/graphql';
import { getContactDetails } from '@ordering/services/contact-details';

export const hasSmsPrompt = (prompts: CheckoutCustomerPrompt[]) => {
  return prompts.some((prompt) => prompt.promptType === CustomerPromptTypes.Sms);
};

export const hasEmailPrompt = (prompts: CheckoutCustomerPrompt[]) => {
  return prompts.some((prompt) => prompt.promptType === CustomerPromptTypes.Email);
};

export const prefillContactDetails = async ({
  hasSms = false,
  hasEmail = false,
}: {
  hasSms?: boolean;
  hasEmail?: boolean;
}): Promise<{
  phoneNumber?: string;
  email?: string;
}> => {
  if (!hasSms && !hasEmail) return {};

  const savedContactDetails = await getContactDetails();
  if (!savedContactDetails) return {};

  return {
    ...(hasSms && savedContactDetails.phoneNumber
      ? { phoneNumber: savedContactDetails.phoneNumber }
      : {}),
    ...(hasEmail && savedContactDetails.email ? { email: savedContactDetails.email } : {}),
  };
};
